var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamingFast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9167 36C71.9167 55.468 56.1348 71.25 36.6667 71.25C17.1987 71.25 1.41675 55.468 1.41675 36C1.41675 16.532 17.1987 0.75 36.6667 0.75C56.1348 0.75 71.9167 16.532 71.9167 36Z",
    stroke: "#E8E9E9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 47V41M41.6667 44H47.6667",
    stroke: "#FFA89E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 31V27M25.6667 29H29.6667",
    stroke: "#FFA89E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 37.25L41.3334 26L38.6667 34.75H42.6667L32.0001 46L34.6667 37.25H30.6667Z",
    stroke: "#EC5341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7077 23.0013C20.2131 27.6224 18.2107 35.2718 20.7582 42.0013",
    stroke: "#FFA89E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9443 44.5002C26.6387 52.6312 37.0358 55.4171 45.1667 50.7227C53.2977 46.0282 56.0836 35.6312 51.3892 27.5002C46.6947 19.3693 36.2977 16.5834 28.1667 21.2778M21.9443 44.5002L20.9132 49.7143M21.9443 44.5002L27.1584 45.5313",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.666748)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingFast);
export default __webpack_public_path__ + "static/media/gaming_fast.144d4d648e0194194c9d64ce0dbac5de.svg";
export { ForwardRef as ReactComponent };